// Predicate for HTTP-mode cron services. An HTTP-mode cron has type: cron AND
// a run field starting with http:// or https://. The platform serves these
// from curlimages/curl on the schedule — there is no source folder, no build,
// no Dockerfile, and nothing to spawn locally. Mirrors the skip predicate in
// packages/shared/src/generator/dockerfile.ts.

interface CronModeShape {
  type?: string;
  run?: unknown;
}

export function isHttpModeCron(svc: CronModeShape): boolean {
  if (svc.type !== 'cron') return false;
  if (typeof svc.run !== 'string') return false;
  return svc.run.startsWith('http://') || svc.run.startsWith('https://');
}
